import axios from './custom_axios';
import Cookies from 'js-cookie';
const API_URL = process.env.REACT_APP_API_URL;

const order = (orderData) => {
    return axios.post(`${API_URL}/api/v1/orders`, orderData)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

const getOrderByUser = async () => {
    const token = Cookies.get("Token");
    if (!token) {
        return;
    }

    try {
        const response = await axios.get(`${API_URL}/api/v1/order-detail`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return { message: 'An error occurred while fetching orders' };
    }
}

const getInvoiceByUser = async () => {
    const token = Cookies.get("Token");
    if (!token) {
        return;
    }

    try {
        const response = await axios.get(`${API_URL}/api/v1/invoice-detail`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        return { message: 'An error occurred while fetching orders' };
    }
}

// Service/Oder.js

export const getInvoiceCSHPByUser = async () => {
    const token = Cookies.get("Token");

    try {
        const response = await axios.get(`${API_URL}/api/v1/cshp-invoice-detail`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching CSHP invoices:', error);
        return { invoice: [] };
    }
};



export { order, getOrderByUser, getInvoiceByUser };